import { pxToRem, responsiveFontSizes } from '../utils/getFontValue';

// ----------------------------------------------------------------------

const FONT_PRIMARY = 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'; // Premium Font Stack
const FONT_SECONDARY = 'Playfair Display, Georgia, serif'; // Luxury Serif Font for Premium Elements

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  fontWeightExtraBold: 800,
  h1: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 700,
    lineHeight: 1.2,
    fontSize: pxToRem(48),
    letterSpacing: '-0.02em',
    ...responsiveFontSizes({ sm: 56, md: 64, lg: 72 }),
  },
  h2: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 600,
    lineHeight: 1.3,
    fontSize: pxToRem(36),
    letterSpacing: '-0.01em',
    ...responsiveFontSizes({ sm: 42, md: 48, lg: 54 }),
  },
  h3: {
    fontWeight: 600,
    lineHeight: 1.4,
    fontSize: pxToRem(28),
    letterSpacing: '-0.005em',
    ...responsiveFontSizes({ sm: 30, md: 34, lg: 38 }),
  },
  h4: {
    fontWeight: 600,
    lineHeight: 1.4,
    fontSize: pxToRem(22),
    letterSpacing: '0em',
    ...responsiveFontSizes({ sm: 24, md: 26, lg: 28 }),
  },
  h5: {
    fontWeight: 600,
    lineHeight: 1.4,
    fontSize: pxToRem(18),
    letterSpacing: '0.01em',
    ...responsiveFontSizes({ sm: 20, md: 22, lg: 24 }),
  },
  h6: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
    letterSpacing: '0.01em',
    ...responsiveFontSizes({ sm: 18, md: 20, lg: 20 }),
  },
  subtitle1: {
    fontWeight: 500,
    lineHeight: 1.6,
    fontSize: pxToRem(16),
    letterSpacing: '0.01em',
  },
  subtitle2: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
    letterSpacing: '0.02em',
  },
  body1: {
    lineHeight: 1.6,
    fontSize: pxToRem(16),
    letterSpacing: '0.01em',
  },
  body2: {
    lineHeight: 1.5,
    fontSize: pxToRem(14),
    letterSpacing: '0.02em',
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(12),
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 600,
    lineHeight: 1.4,
    fontSize: pxToRem(14),
    letterSpacing: '0.02em',
    textTransform: 'none',
  },
  // ERC-721 Premium Typography Variants
  premium: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 600,
    lineHeight: 1.3,
    letterSpacing: '-0.01em',
  },
  luxury: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: '-0.02em',
  },
  price: {
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
    fontFeatureSettings: '"tnum"',
  },
};

export default typography;
